import type { EventListenerList } from "../event"
import { type ActionBindingEvent } from "./ActionBindingEvent.type"
import type { InputActionType } from "./InputActionType"
import { inputRouterMap } from "./inputRouterMap"

export default function getInputActionListenerList(
  action: InputActionType,
): EventListenerList<ActionBindingEvent> {
  let list: EventListenerList<ActionBindingEvent> | undefined = inputRouterMap.get(action)
  if (!list) {
    list = [] as EventListenerList<ActionBindingEvent>
    inputRouterMap.set(action, list)
  }
  return list!
}